import React from 'react';


class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary" role="alert" aria-live="polite">
          <p>This panel encountered an error.</p>
          <button
            className="btn-retry"
            onClick={() => this.setState({ hasError: false })}
            aria-label="Retry panel render"
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
